import View3dTagFactory from './View3dTag'
import View3dToolbar from './View3dToolbar'

module.exports = (modules)->
  {React,Icon,textedit_utils,CollapsePanel,reducers,SharedReducers,slate} = modules
  View3dTag = View3dTagFactory(modules)
     
  # what name to use, should be unique
  name:"View3d"

  tags:{"duoView3d"}

  # html to insert from drag and drop
  drophtml:'<view3d-tag style="height:500px"></view3d-tag>'
  
  # What to render in the toolbar when element is selected
  toolbar:View3dToolbar(modules)
  
  # what icon to show in media elements
  icon:(props)-> 
    <React.Fragment>
      <div style={{border:"1px solid rgba(255.255.255.0.1)",width:48,height:35,margin:"0 auto",position:"relative"}}>
        <svg width="2.5em" height="2.5em" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" d="m50 3.5898 20.375 11.766 18.145 10.473-38.52 22.238-38.52-22.238 18.145-10.477 20.375-11.766zm40.754 26.113v44.477l-20.379 11.766-18.133 10.469v-44.477zm-43 66.711-18.133-10.469-20.379-11.766v-44.477l38.508 22.234v44.477z" fill-rule="evenodd"/>
        </svg>
      </div>
      <span className="label">3d Viewer</span>
    </React.Fragment>

  plugins:[{ 
    schema:
      blocks:
        duoView3d:
          isVoid: true
  }]
  
  # convert AST to HTML
  serialize:(object, children)->
    if object.type == "duoView3d"
      return <view3d-tag style="height:500px" style={object.data.get("style")} src={object.data.get("src")}></view3d-tag>

  # convert HTML to AST
  deserialize:(el,next)->
    return if el.tagName.toLowerCase()!="view3d-tag"
    attributes = textedit_utils.attributesFromElement(el)
    {
      object: 'block',
      type: "duoView3d",
      isVoid: true,
      data: {...attributes,style: (if el.getAttribute('style') then textedit_utils.style2object(el.getAttribute('style')) else {}),className:el.getAttribute('class')}
    }
  
  # convert AST to inpage editing component
  renderNode:({attributes, children, node, isSelected, editor} )->
    return if node.type!="duoView3d"
    attributes.style = {} if !attributes.style
    attributes = Object.assign({},attributes,{className:node.data.toObject().className})
    props = node.data.toObject()
    <View3dTag attributes={attributes} props={props} node={node} isSelected={isSelected} editor={editor} name={@name}></View3dTag>

